"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importStar(require("react"));

var Portal_1 = __importDefault(require("reactstrap/src/Portal"));

var Drawer =
/** @class */
function (_super) {
  __extends(Drawer, _super);

  function Drawer(props) {
    var _this = _super.call(this, props) || this;

    _this.classModificationDelay = 200;

    _this.handleProps = function (props) {
      if (_this.state.show === false && props.isOpen === true) {
        _this.open();
      }

      if (_this.state.show === true && props.isOpen === false) {
        _this.close();
      }
    };

    _this.open = function () {
      _this.setState({
        displayState: 'flex'
      });

      window.setTimeout(function () {
        _this.setState({
          show: true
        });
      }, 15);
    };

    _this.close = function () {
      _this.setState({
        show: false
      });

      window.setTimeout(function () {
        _this.setState({
          displayState: 'none'
        });
      }, _this.classModificationDelay);
    };

    _this.handleClick = function (event) {
      // if the drawer, and nothing else was clicked.
      if (event.target === event.currentTarget && _this.props.clickOutsideToDismiss !== false) {
        _this.close();

        if (_this.props.onClickOut) {
          _this.props.onClickOut();
        }
      }
    };

    _this.state = {
      displayState: 'none',
      show: false
    };
    return _this;
  }

  Drawer.prototype.componentDidMount = function () {
    this.handleProps(this.props);
  };

  Drawer.prototype.componentWillReceiveProps = function (newProps) {
    this.handleProps(newProps);
  };

  Drawer.prototype.render = function () {
    var className = "drawer " + (this.state.show ? 'show' : '') + " " + ("drawer-" + this.props.side + " d-" + this.state.displayState + " ") + ("" + (this.props.fullScreenOnMobile === true ? 'drawer-body-fullscreen-mobile' : ''));
    return react_1["default"].createElement(Portal_1["default"], null, react_1["default"].createElement("div", {
      className: className,
      onClick: this.handleClick,
      style: {
        cursor: this.props.clickOutsideToDismiss === true ? 'pointer' : 'default'
      }
    }, react_1["default"].createElement("div", {
      className: "drawer-body d-flex " + (this.props.className || ''),
      style: {
        cursor: 'default'
      }
    }, this.props.children)));
  };

  return Drawer;
}(react_1.Component);

exports["default"] = Drawer;